import { Directive, ElementRef, Input, OnInit } from '@angular/core';

@Directive({
    selector: '[appMarkAsterisk]',
    standalone: false
})
export class MarkAsteriskDirective implements OnInit {
  @Input() formControlObj!: any;

  constructor(private elementRef: ElementRef) {
  }

  ngOnInit(): void {
    const isRequired = this.formControlObj?.errors?.['required'];
    if (isRequired) {
      this.elementRef.nativeElement.innerHTML = '*';
    } else {
      this.elementRef.nativeElement.innerHTML = '';
    }
  }
}
